/* eslint-disable react/require-default-props */
import { ReactNode, useMemo } from "react";
import { DsmIcon } from "@dsm-dcs/design-system-react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import { processAndStageStylesV2 } from "../../../../../_metronic/layout";
import { CSSClassesList } from "../../../helpers/helperTypes";

type DialogVariant = "small" | "normal" | "semiWide" | "wide";

type IconVariant = "completed" | "inProgress" | "warning" | "error";

type DsmDialogProps = {
  openDialog: boolean;
  title: string;
  description?: string;
  icon?: { name: string; variant?: IconVariant };
  children?: ReactNode;
  variant?: DialogVariant;
  handleClose: () => void;
};

const variantWidths: Record<DialogVariant, string> = {
  small: "400px",
  normal: "640px",
  semiWide: "1024px",
  wide: "1280px",
};

const DsmDialog = ({
  openDialog,
  title,
  description,
  icon,
  children,
  variant = "normal",
  handleClose,
}: DsmDialogProps) => {
  const classes: CSSClassesList = processAndStageStylesV2();

  const getDialogWidth = useMemo(
    () => variantWidths[variant] || variantWidths.normal,
    [variant],
  );

  return (
    <Dialog
      open={openDialog}
      maxWidth={false}
      scroll="body"
      PaperProps={{
        style: {
          padding: "var(--dsm-spacing-px-6)",
          width: getDialogWidth,
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        disableTypography
        style={{ padding: 0 }}
      >
        {icon && (
          <Box className={clsx(classes.iconHolder, icon.variant)}>
            <DsmIcon
              name={icon.name}
              className={clsx(classes.iconInTheBox, icon.variant)}
            />
          </Box>
        )}

        <IconButton
          aria-label="close"
          className={classes.dialogCloseBtn}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>

        <Box style={icon && { marginTop: "20px" }}>{title}</Box>

        {description && (
          <Typography style={{ marginTop: "16px" }}>{description}</Typography>
        )}
      </DialogTitle>

      {children && (
        <DialogContent style={{ padding: 0 }}>{children}</DialogContent>
      )}
    </Dialog>
  );
};

export default DsmDialog;
